<mat-dialog-actions class="justify-content-between">
    <h3 *ngIf="!isUpdate">{{ 'LABEL.ADD_LABEL' | translate }} {{ 'ENTITY.APPOINTMENT' | translate }}</h3>
    <h3 *ngIf="isUpdate">{{ 'LABEL.UPDATE_LABEL' | translate }} {{ 'ENTITY.APPOINTMENT' | translate }}</h3>
    <button mat-icon-button mat-dialog-close class="d-flex justify-content-center">
        <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
    </button>
</mat-dialog-actions>
<mat-divider></mat-divider>
<mat-dialog-content>
    <form [formGroup]="AppointmentAddForm">
        <div class="row">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.NAME' | translate }}</mat-label>
                    <input matInput placeholder="Name" [matAutocomplete]="auto" formControlName="patientId"
                        [readonly]="isUpdate" />
                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn">
                        <mat-option *ngIf="shouldShowAddOption(AppointmentAddForm.get('patientId')?.value)"
                            [value]="AppointmentAddForm.get('patientId')?.value" class="mat-option-add"
                            (click)="addPatient()">
                            <span class="f-w-700">Add "{{ AppointmentAddForm.get('patientId')?.value }}"</span>
                        </mat-option>
                        <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                            {{ option.name }}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error
                        *ngIf="AppointmentAddForm.get('patientId')?.invalid && 
                                    (AppointmentAddForm.get('patientId')?.dirty || AppointmentAddForm.get('patientId')?.touched)">
                        {{ 'REQUIRED.NAME' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.DATE' | translate }}</mat-label>
                    <input matInput [matDatepicker]="picker" [matDatepickerFilter]="dateFilter"
                        formControlName="appointDate" required placeholder="Date" readonly
                        (dateChange)="onDateChange($event)">
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker [color]="'primary'"></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="col-lg-6">
                <mat-form-field appearance="outline" class="w-100">

                    <mat-label>{{ 'LABEL.TIME' | translate }}</mat-label>
                    <mat-select formControlName="appointTime">
                        <mat-option *ngFor="let slot of timeSlot" [value]="slot.time" [disabled]="slot.appointment">
                            {{ slot.time }}
                        </mat-option>
                    </mat-select>

                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'ENTITY.APPOINTMENT_TYPE' | translate }}</mat-label>
                    <mat-select formControlName="appointmentTypeId">
                        <mat-option (click)="openAppointmentTypeDialog()">
                            <span class="f-w-600 f-s-15">{{ 'LABEL.ADD_LABEL' | translate }} New {{
                                'ENTITY.APPOINTMENT_TYPE' | translate }}</span>
                        </mat-option>
                        <mat-option *ngFor="let appointment of appointmentTypeList" [value]="appointment.id">
                            {{appointment.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.STATUS' | translate }}</mat-label>
                    <mat-select formControlName="status">
                        <mat-option disabled>Select Status</mat-option>
                        <mat-option *ngFor="let status of statusList" [value]="status">
                            {{statusData[status]}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </form>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions class="d-flex justify-content-end">
    <div class="row p-r-16">
        <div class="col-lg-8"></div>
        <div class="col-lg-4 d-flex justify-content-end">
            <button mat-stroked-button class="m-r-5" (click)="onCloseDialog()">{{ 'BUTTON.BTN_CLOSE' | translate
                }}</button>
            <button mat-flat-button color="primary" (click)="onSaveAppointment()" *ngIf="!isUpdate"
                [disabled]="AppointmentAddForm.invalid || isPatientSelected">
                {{ 'BUTTON.BTN_SAVE' | translate }}</button>
            <button mat-flat-button color="primary" (click)="onUpdateAppointment()" *ngIf="isUpdate"
                [disabled]="AppointmentAddForm.invalid">{{ 'BUTTON.BTN_SAVE' | translate }}
            </button>
        </div>
    </div>
</mat-dialog-actions>